import { FILE_CONFIG } from "../constants";

export const createImagePreview = (file) => {
  return new Promise((resolve, reject) => {
    console.log(
      "🔍 Creating preview for file:",
      file.name,
      "Size:",
      file.size,
      "Type:",
      file.type
    );

    if (!file) {
      reject(new Error("No file provided"));
      return;
    }

    // Validate file type
    if (!file.type.startsWith("image/")) {
      reject(new Error("File must be an image"));
      return;
    }

    // Validate file size
    if (file.size > FILE_CONFIG.maxSize) {
      reject(
        new Error(
          `File size must be less than ${FILE_CONFIG.maxSize / 1024 / 1024}MB`
        )
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      console.log("✅ Preview created successfully for:", file.name);
      resolve(event.target.result);
    };

    reader.onerror = (error) => {
      console.error("❌ Error creating preview:", error);
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

export const validateFile = (file) => {
  console.log(
    "🔍 Validating file:",
    file?.name,
    "Type:",
    file?.type,
    "Size:",
    file?.size
  );

  if (!file) {
    return { valid: false, error: "No file selected" };
  }

  if (!file.type.startsWith("image/")) {
    return { valid: false, error: "Please select an image file" };
  }

  if (file.size > FILE_CONFIG.maxSize) {
    return {
      valid: false,
      error: `File size must be less than ${
        FILE_CONFIG.maxSize / 1024 / 1024
      }MB`,
    };
  }

  console.log("✅ File validation passed for:", file.name);
  return { valid: true };
};

export const resetFileInput = (inputId) => {
  console.log("🔄 Resetting file input:", inputId);
  const fileInput = document.getElementById(inputId);
  if (fileInput) {
    fileInput.value = "";
    console.log("✅ File input reset successfully");
  } else {
    console.warn("⚠️ File input not found:", inputId);
  }
};
